// Canonical parser for a semicolon-separated qualitative QC value string, shared by lot editing and
// material-definition validation. Splits only on `;` (commas stay inside a value), trims each token,
// drops empty tokens, and preserves exact case — no case-folding, translation, or deduplication.
export const tokenizeQcValues = (raw?: string): string[] =>
    (raw ?? '')
        .split(';')
        .map((token) => token.trim())
        .filter((token) => token !== '');
